/**
 * Clés du cache TanStack Query, en un seul endroit.
 *
 * Une écriture qui périme une lecture (`invalidateQueries`) doit viser la même clé que la
 * lecture : les définir ici évite qu'un écran invalide `['contract']` quand l'autre lit
 * `['contracts', id]`.
 */
export const queryKeys = {
    user: ['user'] as const,
    whitelabel: (id: unknown) => ['whitelabel', id] as const,
    whitelabelByHost: (host: unknown) => ['whitelabel', 'host', host] as const,
    contracts: ['contracts'] as const,
    /** Contrats en attente de pièces (`contracts?waiting_document=true`), hors du préfixe `contracts`. */
    waitingDocContracts: ['waiting-doc-contracts'] as const,
    faq: (faqType: unknown) => ['faq', faqType] as const,
    parrainages: (tiersId: unknown) => ['parrainages', String(tiersId)] as const,
    /** Pièces d'un contrat (`GET /contracts/{id}/documents`). */
    contractDocuments: (contractId: unknown) => ['documents', 'contract', String(contractId)] as const,
    receiptsUnpaid: ['receipts', 'unpaid'] as const,
    /** Quittances d'un contrat (`GET /contracts/{id}/receipts`). */
    contractReceipts: (contractId: unknown) => ['receipts', 'contract', String(contractId)] as const,
    /** Véhicules d'une flotte : URL complète (page + filtres). */
    fleet: (url: unknown) => ['fleet', 'list', String(url)] as const,
    fleetVehicle: (url: unknown) => ['fleet', 'detail', String(url)] as const,
    /** Tableau de prélèvement d'un contrat (`GET /contracts/{id}/direct-debits`). */
    contractPrelevements: (contractId: unknown) => ['receipts', 'prelevements', String(contractId)] as const,
    /** Lien de prise de rendez-vous « fidélisation » proposé à la résiliation. */
    bookingFidelisation: (contractId: unknown) => ['booking', 'fidelisation', String(contractId)] as const,
    contract: (id: unknown) => ['contracts', 'detail', String(id)] as const,
    accidentsTiers: (tiersId: unknown) => ['accidents', 'tiers', String(tiersId)] as const,
    accidentsContract: (contractId: unknown) => ['accidents', 'contract', String(contractId)] as const,
    accident: (contractId: unknown, accidentId: unknown) =>
        ['accidents', 'detail', String(contractId), String(accidentId)] as const,
} as const;
